export const finishedOrderStatuses = {
    rejected: "Скасоване",
    closed: "Завершене",
}
